<!-- 弹窗组件 -->
<template>
  <div v-if="modelValue" class="modal-overlay" @click.self="handleOverlayClick">
    <div class="modal-content">
      <div v-if="showIcon" class="modal-icon">
        <slot name="icon">
          <img :src="iconSrc" alt="" v-if="iconSrc">
          <img src="./success.png" alt="" v-else-if="status === 'success'">
          <img src="./warn.png" alt="" v-else-if="status === 'warn'">
          <img src="./error.png" alt="" v-else>
        </slot>
      </div>
      <div class="modal-title">{{ title }}</div>
      <div class="modal-description">
        <span class="modal-description" v-if="description">{{ description }}</span>
        <span class="modal-description" v-if="billingAddress" style="margin-top: 4px;">
          {{ $t('message.checkout.billingAddressTip', { billingAddress: billingAddress }) }}
        </span>

        <span class="modal-description countdown-text" v-if="showCountdownText"
          v-html="$t('message.result.autoRedirectCountdown', { seconds: `<span class='countdown-number'>${countdown}</span>` })">
        </span>
      </div>
      <div class="modal-divider" v-if="redirectUrl"></div>
      <slot></slot>
      <!-- 倒计时文案显示区域 -->
      <div class="modal-button-container" v-if="redirectUrl || customButtonClick">
        <on-button @click="handleButtonClick" :customStyle="buttonStyle">{{ buttonText }}</on-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Modal',
  // 作者: Nemo
  // 功能: 支持自动倒计时跳转的弹窗组件
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    status: {
      type: String,
      default: 'success',
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    customButtonClick: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default() {
        return this.$t('message.checkout.returnMerchant');
      },
    },
    closeOnOverlayClick: {
      type: Boolean,
      default: true,
    },
    redirectUrl: {
      type: String,
      default: '',
    },
    iconSrc: {
      type: String,
      default: '',
    },
    billingAddress: {
      type: String,
      default: '',
    },
    // 订单信息对象
    order: {
      type: Object,
      default: null,
    },
    // 自动跳转倒计时秒数
    autoRedirectSeconds: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      // 当前倒计时数值
      countdown: 0,
      // 定时器引用
      countdownTimer: null,
    };
  },
  computed: {
    ...mapGetters(['app']),
    buttonStyle() {
      return {
        width: 'auto',
        minWidth: '160px',
        maxWidth: '100%',
        padding: '8px 24px',
      };
    },
    // 是否启用自动跳转功能（从brandInfo中获取）
    autoRedirect() {
      // 做好判空处理：app -> brandInfo -> autoRedirect
      // 只有在brandInfo存在且autoRedirect明确为true时才启用
      return this.app.brandInfo?.autoRedirect === true;
    },
    // 是否显示倒计时文案
    showCountdownText() {
      return this.app.brandInfo?.autoRedirect === true;
    },
  },
  watch: {
    modelValue(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
        // 如果启用自动跳转，开始倒计时
        if (this.autoRedirect) {
          this.startCountdown();
        }
      } else {
        document.body.style.overflow = '';
        // 清除倒计时
        this.clearCountdown();
      }
    },
  },
  methods: {
    handleOverlayClick() {
      if (this.closeOnOverlayClick) {
        this.$emit('update:modelValue', false);
      }
    },

    handleButtonClick() {
      // 清除倒计时
      this.clearCountdown();

      if (this.customButtonClick) {
        this.$emit('click');
      } else {
        if (this.redirectUrl) {
          window.location.href = this.redirectUrl;
        } else {
          this.$emit('update:modelValue', false);
        }
      }
    },

    // 开始倒计时
    startCountdown() {
      if (!this.autoRedirect) return;

      this.countdown = this.autoRedirectSeconds;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.clearCountdown();
          // 自动执行跳转
          this.handleButtonClick();
        }
      }, 1000);
    },

    // 清除倒计时
    clearCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      this.countdown = 0;
    },
  },
  beforeDestroy() {
    // 清除定时器防止内存泄漏
    this.clearCountdown();
  },
};
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(102, 112, 133, 0.7);
  z-index: 10000;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(10px);
}

.modal-content {
  background: #FFFFFF;

  width: 600px;
  top: 265px;

  border-radius: 18px;
  border-width: 1px;
  padding: 24px;

}

.modal-icon {
  // margin: 0 auto 16px;
  width: 40px;
  height: 40px;
  padding: 4px;
  margin-bottom: 24px;

  img {
    width: 100%;
    height: 100%;
  }
}

.modal-title {

  text-align: left;
  font-family: Open Sans regular;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0px;
  margin-bottom: 24px;
  color: rgba(26, 32, 44, 1);

}

.modal-description {
  margin-bottom: 24px;
  text-align: left;

  font-family: Open Sans regular;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0px;
  color: rgba(102, 112, 133, 1);
}

.modal-divider {
  height: 1px;
  background: rgba(239, 239, 244, 1);
  margin-bottom: 17px;
}

.modal-button-container {
  display: flex;
  justify-content: end;
  margin-top: 20px;
}

.countdown-text {
  margin-left: 4px;

  :deep(.countdown-number) {
    color: var(--brand-color, #503df6);
    font-weight: 700;
  }
}
</style>
